import { Component } from '@angular/core';

@Component({
  selector: 'cdm-manizales-card-notification',
  templateUrl: './card-notification.component.html',
  styleUrls: ['./card-notification.component.scss'],
})
export class CardNotificationComponent {}
